import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=48cb89b6"
import script from "./Burger.vue?vue&type=script&lang=ts"
export * from "./Burger.vue?vue&type=script&lang=ts"
import style0 from "./Burger.vue?vue&type=style&index=0&id=48cb89b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports